<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Clientes</h1>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.search" class="w-full max-w-md mr-4" label="Cliente" />
      <select-2-input v-model="form.cidade" :filterable="false" :options="cidades" :get-option-label="option =>`${option.cidade} - ${option.uf}` " label="Cidade" class="w-full max-w-md mr-4" @search="onSearch">
        <template slot="no-options">
          Pesquise uma cidade
        </template>
      </select-2-input>
    </div>
    <div class="mb-6 flex justify-between items-center">
      <text-input v-model="form.ultimoAcesso" type="date" value-type="YYYY-MM-DD" clear range class="w-full max-w-md mr-4" label="Último Acesso" />
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Cliente</th>
          <th class="px-6 pt-6 pb-4">Modulos</th>
          <th class="px-6 pt-6 pb-4">Último Acesso</th>
        </tr>
        <tr v-for="cliente in clientes.data" :key="cliente.idPessoa" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('clientes.details', cliente.idPessoa)">
              {{ cliente.razaoSocial }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('clientes.details', cliente.idPessoa)" tabindex="-1">
              {{ getLicencasText(cliente.licencas) }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('clientes.details', cliente.idPessoa)" tabindex="-1">
              {{ getUltimoAcesso(cliente.datahh) }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('clientes.details', cliente.idPessoa)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="clientes.data.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhum Cliente Encontrado.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="clientes.links" :query="filters" />
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import debounce from 'lodash/debounce'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import TextInput from '../../Shared/TextInput.vue'
import Select2Input from '../../Shared/Select2Input.vue'
import { DateTime } from 'luxon'
export default {
  metaInfo: { title: 'Clientes' },
  components: {
    Icon,
    Pagination,
    TextInput,
    Select2Input,
  },
  layout: Layout,
  props: {
    filters: Object,
    clientes: Object,
    cidades: Array,
  },
  data() {
    return {
      options: [],
      selectedCidade:'',
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        cidade: this.filters.cidade,
        ultimoAcesso: this.filters.ultimoAcesso,
        searchCidade: this.filters.searchCidade,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: debounce(function() {
        this.$inertia.get(this.route('clientes'), pickBy(this.form), { preserveState: true })
      }, 500),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    onSearch(search) {
      if(search.length) {
        this.form.searchCidade=search
      }
    },
    onSelectedCidade(cidade) {
      this.form.cidade=cidade
    },
    getLicencasText(array){
      const modulos = array.map(e =>e.codModulo)
      const uniq = [...new Set(modulos)]
      return uniq.join(',')
    },
    getUltimoAcesso(log){
      if(!log){
        return '-'
      }
      const dtUltimoAcesso = DateTime.fromSQL(log)

      return dtUltimoAcesso.toFormat('dd/MM/yyyy H:mm')

    },
    changeCidade(objCidade){
      this.form.cidade =objCidade.codCidade
    },
  },


}
</script>
